import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Paper,
  Divider,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import API from "../utils/api";
import { toast } from "react-toastify";
import { alpha } from "@mui/material/styles";

export default function AddTaskPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    due_date: "",
    created_by: "",
    assigned_to: "",
    priority: "",
    status: "To Do",
  });

  const [users, setUsers] = useState([]);
  const priorities = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
 
];


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await API.get("/users/");
        setUsers(res.data);
      } catch (err) {
        console.error("Error fetching users:", err);
        toast.error("❌ Failed to load users");
      }
    };
    fetchUsers();
  }, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (!formData.title || !formData.due_date || !formData.assigned_to) {
      toast.error("⚠️ Please fill all required fields");
      return;
    }

    try {
      await API.post("/tasks/", formData);
      toast.success("Task created successfully!");
      navigate("/tasks");
    } catch (err) {
      console.error("Error saving task:", err.response?.data || err.message);
      toast.error("Failed to create task");
    }
  };

  const handleBack = () => navigate("/tasks");

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        minHeight: "100vh",
        p: { xs: 0, md: 3 },
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, md: 4 },
          width: { xs: "calc(100vw - 5px)", md: "600px" },
          maxWidth: "100%",
          borderRadius: "16px", // Keep rounded corners on mobile
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
          mt: { xs: 0, md: 4 },
          mx: { xs: "2.5px", md: 0 },
        }}
      >
        {/* Unified Header */}
<Box
  sx={{
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    borderRadius: "12px 12px 0 0",
    px: 3,
    py: 2.5,
    mb: 3,
  }}
>
  <Typography
    variant="h6"
    sx={{
      color: "primary.main",
      fontWeight: 700,
      letterSpacing: 0.3,
    }}
  >
    Add Task
  </Typography>
  <Typography
    variant="body2"
    color="text.secondary"
    sx={{ mt: 0.5 }}
  >
    Create a new task assign it to a user, and set priority and due date.
  </Typography>
</Box>

        <Divider
          sx={{
            mb: 3,
            borderColor: theme.palette.divider,
          }}
        />

        {/* Form Fields */}
        <Box
          component="form"
          display="flex"
          flexDirection="column"
          gap={3}
        >
          <TextField
            fullWidth
            label="Title"
            value={formData.title}
            onChange={(e) => handleChange("title", e.target.value)}
            variant="outlined"
          />

          <TextField
            fullWidth
            multiline
            minRows={5}
            label="Description"
            value={formData.description}
            onChange={(e) => handleChange("description", e.target.value)}
            variant="outlined"
          />

          <TextField
            type="date"
            fullWidth
            label="Due Date"
            InputLabelProps={{ shrink: true }}
            value={formData.due_date}
            onChange={(e) => handleChange("due_date", e.target.value)}
            variant="outlined"
          />

          <TextField
            select
            fullWidth
            label="Created By"
            value={formData.created_by}
            onChange={(e) => handleChange("created_by", e.target.value)}
            variant="outlined"
          >
            {users.map((u) => (
              <MenuItem key={u.id} value={u.id}>
                {u.username}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            fullWidth
            label="Assigned To"
            value={formData.assigned_to}
            onChange={(e) => handleChange("assigned_to", e.target.value)}
            variant="outlined"
          >
            {users.map((u) => (
              <MenuItem key={u.id} value={u.id}>
                {u.username}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            fullWidth
            label="Priority"
            value={formData.priority}
            onChange={(e) => handleChange("priority", e.target.value)}
            variant="outlined"
          >
            {priorities.map((p) => (
  <MenuItem key={p.value} value={p.value}>
    {p.label}
  </MenuItem>
))}

          </TextField>
        </Box>

        {/* Footer Buttons */}
        <Box
          display="flex"
          justifyContent="space-between"
          gap={2}
          mt={3}
         
          
          sx={{ backgroundColor: "inherit" }}
        >
          <Button
            variant="outlined"
            color="inherit"
            onClick={handleBack}
            sx={{ width: "48%" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            sx={{ width: "48%" }}
          >
            Save Task
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
